module.exports = __webpack_public_path__ + "static/media/email.e9e0a696.svg";